export const ChannelOverview = (builder) => ({
    ChannelOverview: builder.mutation({
        query: ({ userId, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/channeloverview',
                method: 'GET',
                params: { userId, startDate, endDate },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});